import { TextInput } from './TextInput';

interface SimpleFieldProps {
    width: string;
    error?: string;
    required: boolean;
    showPopoverTooltip?: boolean;
    popoverTooltipMessage?: string;
    name?: string;
    id?: string;

    fieldLabel: string;
    fieldValidationMessage?: string | null;
    fieldTouched: boolean | undefined;
    fieldValue: string;
    fieldDisabled?: boolean;
    fieldPlaceholder?: string;

    setFieldValue(value: string): void;
    touchField(): void;
}

export const SimpleInputField = (props: SimpleFieldProps) => {
    return (
        <TextInput
            className={`col-xs-12 ${props.width}`}
            value={props.fieldValue}
            label={props.fieldLabel}
            placeholder={props.fieldPlaceholder}
            name={props.name}
            popoverTooltip={props.showPopoverTooltip}
            popoverTooltipMessage={props.popoverTooltipMessage}
            disabled={props.fieldDisabled}
            required={props.required}
            // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
            onChange={(evt: any) => props.setFieldValue(evt.target.value)}
            error={
                props.fieldTouched && props.fieldValidationMessage !== null ? props.fieldValidationMessage : undefined
            }
            // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
            onBlur={(evt: any) => {
                props.setFieldValue(evt.target.value?.trim());
                props.touchField();
            }}
        />
    );
};
